var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    {
      staticClass: "full-width",
      attrs: {
        placeholder: _vm.$t("chooseText"),
        multiple: _vm.multiple,
        disabled: _vm.disabled || !_vm.isSuperAdmin,
        filterable: "",
        clearable: "",
      },
      on: { clear: _vm.onClear },
      model: {
        value: _vm.id,
        callback: function ($$v) {
          _vm.id = $$v
        },
        expression: "id",
      },
    },
    _vm._l(_vm.BJ_TENANTS, function (item, index) {
      return _c("el-option", {
        key: index,
        attrs: { label: item.label, value: item.value },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }